import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
import { checkoutUrl, priceSavings, priceToday, priceTotal, valueRows } from '../data/content';
export function ValueStack() {
  return <section id="comprar" className="w-full scroll-mt-20 bg-surface px-5 py-12 sm:py-20" data-id="element-257" data-mp="1qapjht2zetyi">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-[600px]" data-id="element-258" data-mp="1uc10xbbpc8vm">
        <h2 className="text-center font-display text-2xl font-bold text-foreground sm:text-4xl" data-id="element-259" data-mp="2980fn4tbh79q">
          Todo lo que <span className="text-pink" data-id="element-260" data-mp="2d7r5n6b0rjd7">recibís hoy</span>
        </h2>

        <div className="mt-6 rounded-2xl border border-line p-4 sm:mt-8 sm:p-6" data-id="element-261" data-mp="30ymze8z1con3">
          <ul data-id="element-262" data-mp="35p3f5zqbwmcm">
            {valueRows.map(row => <li key={row.label} className="flex items-center justify-between gap-3 border-b border-dashed border-line py-2 last:border-b-0 sm:py-2.5" data-id="element-263" data-mp="35q53v709p7ct">
                <span className="text-[13px] text-foreground/85 sm:text-sm" data-id="element-264" data-mp="1td0g0oe559kp">{row.label}</span>
                <span className="shrink-0 text-[13px] font-medium text-muted sm:text-sm" data-id="element-265" data-mp="1oeffsoyw2pw9">
                  {row.price}
                </span>
              </li>)}
          </ul>

          <div className="my-4 h-px w-full bg-line" data-id="element-266" data-mp="1ycvat311ejb1" />

          <div className="flex items-center justify-between gap-3" data-id="element-267" data-mp="2c5bem61rild0">
            <span className="text-[13px] text-muted sm:text-sm" data-id="element-268" data-mp="2c7p8ibkphriz">Valor total del método</span>
            <span className="text-lg font-medium text-line line-through decoration-muted/60 sm:text-xl" data-id="element-269" data-mp="286c1hy5vniah">
              {priceTotal}
            </span>
          </div>

          <div className="mt-4 flex flex-col items-center rounded-xl bg-blush py-5 text-center sm:py-6" data-id="element-270" data-mp="2h68ugbzav3bc">
            <span className="text-sm font-medium text-foreground" data-id="element-271" data-mp="rqj7s8hip2wn">Tu inversión hoy</span>
            <span className="font-display text-5xl font-bold text-pink sm:text-6xl" data-id="element-272" data-mp="ms7xxxr82sef">
              {priceToday}
            </span>
            <span className="mt-3 inline-flex items-center rounded-full border border-pink/30 bg-surface px-3 py-1 text-xs font-bold text-pink sm:text-sm" data-id="element-273" data-mp="2mv8vc8xlpmck">
              {priceSavings}
            </span>
            <p className="mt-3 px-4 text-xs text-muted sm:text-sm" data-id="element-274" data-mp="2vvyjqrkj8ag9">
              Pago único · Sin suscripción · Acceso de por vida · Pagás en tu moneda local
            </p>
          </div>
        </div>

        <div className="mt-6 sm:mt-8" data-id="element-275" data-mp="35q7bhd1qnzdd">
          

          <CTAButton href={checkoutUrl} data-id="element-276" data-mp="3aq37ap0a8khu" />
          <TodayOfferCard data-id="element-277" data-mp="3aos1ykr6v4om" />
          <div className="mt-4 rounded-xl border border-primary/20 bg-lilac px-4 py-3 text-center" data-id="element-278" data-mp="3fi38eks39jg0">
            <p className="text-sm font-bold text-primary-strong" data-id="element-279" data-mp="3jjyb9tpo44vw">Pagá fácil desde tu país</p>
            <p className="mt-1 text-xs leading-relaxed text-muted sm:text-sm" data-id="element-280" data-mp="3oirrvv094c0a">
              El precio está en dólares, pero pagás con tu medio de pago habitual: el checkout lo
              convierte automáticamente a tu moneda. Recibís el acceso al instante en tu correo.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}